import React from 'react';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  variant?: 'default' | 'white';
  className?: string;
  textClassName?: string;
}

const sizeConfig = {
  sm: { logo: 'w-8 h-8', text: 'text-lg' },
  md: { logo: 'w-10 h-10', text: 'text-xl' },
  lg: { logo: 'w-12 h-12', text: 'text-2xl' },
};

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 'md',
  showText = true,
  variant = 'default',
  className,
  textClassName,
}) => {
  const s = sizeConfig[size];
  const logoSrc = variant === 'white' ? '/logo-white.svg' : '/logo.svg';

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src={logoSrc}
        alt="Agentive Property"
        className={cn(s.logo, 'flex-shrink-0')}
      />
      {showText && (
        <span
          className={cn(
            s.text,
            'font-bold',
            variant === 'white' ? 'text-white' : 'text-foreground',
            textClassName
          )}
        >
          Agentive Property
        </span>
      )}
    </div>
  );
};
